import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ChatbotComponent } from './chatbot.component';
import { ChatbotFabComponent } from './chatbot-fab.component';
import { ChatbotMessagesComponent } from './chatbot-messages.component';

@NgModule({
  declarations: [
    ChatbotComponent,
    ChatbotFabComponent,
    ChatbotMessagesComponent
  ],
  exports: [
    ChatbotComponent,
    ChatbotFabComponent
  ],
  imports: [
    CommonModule,
    FormsModule
  ]
})
export class ChatbotModule {}
